import { RouterStore } from 'mobx-react-router'
import {
  PersonsTableStore, PersonStore,
  PERSONS_TABLE_STORE, PERSON_STORE, ROUTING_STORE
} from 'store'

export type PersonsPageProps = {
  [PERSON_STORE]?: PersonStore
  [PERSONS_TABLE_STORE]?: PersonsTableStore
  [ROUTING_STORE]?: RouterStore
}

// export const personsTableWidths = {
//   name: 25,
//   roles: 14,
//   projects: 21,
//   addedAt: 14,
//   tags: 26
// }

export const personsTableWidths = {
  name: 450,
  roles: 280,
  projects: 400,
  addedAt: 225,
  tags: 450
}
